export default "__VITE_ASSET__7cebd773__"